var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheck02({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5206 4.25023C11.7506 4.53774 11.704 4.95726 11.4165 5.18727C10.6517 5.79913 9.87268 6.83263 9.19119 7.92863C8.51789 9.01147 7.97454 10.098 7.66915 10.7643C7.56608 10.9892 7.34697 11.1385 7.09998 11.1522C6.85298 11.1658 6.61872 11.0416 6.49145 10.8295C6.27275 10.465 5.87064 9.97931 5.42563 9.51344C4.98219 9.04921 4.54267 8.65306 4.2746 8.4581C3.97683 8.24154 3.911 7.8246 4.12756 7.52683C4.34412 7.22906 4.76106 7.16323 5.05883 7.37979C5.41838 7.64128 5.92031 8.10099 6.38978 8.59247C6.57641 8.78784 6.76532 8.99595 6.94372 9.20673C7.24746 8.61205 7.62712 7.91899 8.0589 7.22458C8.76105 6.09535 9.63669 4.90363 10.5836 4.14611C10.8711 3.91611 11.2906 3.96272 11.5206 4.25023Z",
    fill: "#116584"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck02);
export default __webpack_public_path__ + "static/media/ic-check-02.55da594cc43e34ed48ed32dee546496e.svg";
export { ForwardRef as ReactComponent };